import { isPixiesetAuthEnabled } from "./measurement/feature-flag"

/**
 * Returns the product name based on the pixieset auth feature flag.
 * - Flag enabled: "Pixieset Photo Editor"
 * - Flag disabled: "Polarr Next"
 */
export const getProductName = (): string => {
	return isPixiesetAuthEnabled() ? "Pixieset Photo Editor" : "Polarr Next"
}

/**
 * Returns the company name based on the pixieset auth feature flag.
 * - Flag enabled: "Pixieset"
 * - Flag disabled: "Polarr Next"
 */
export const getCompanyName = (): string => {
	return isPixiesetAuthEnabled() ? "Pixieset" : "Polarr Next"
}

export const getCompanyNameShort = (): string => {
	return isPixiesetAuthEnabled() ? "Pixieset" : "Polarr"
}
